export default __webpack_public_path__ + "static/media/2.7694ec30.png";